import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';

const OnboardingRoute = ({ children }) => {
  const { currentUser, userData } = useAuth();

  // If user is logged in AND has already completed onboarding, redirect to home
  if (currentUser && userData?.familyId) {
    return <Navigate to="/" replace />;
  }

  // Otherwise, show the onboarding page
  return children;
};

export default OnboardingRoute;